<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
:width="width" :height="height"><title>{{title}}</title><g :fill="fill"><path
d="M18.875 0H4.4a1.533 1.533 0 0 0-1.275 1.573v17.475a1.74 1.74 0 0 0 1.1
1.625l8 3.2a1.75 1.75 0 0 0 2.4-1.625v-17a1.744 1.744 0 0
0-1.1-1.625l-2.861-1.141A.25.25 0 0 1 10.757 2h7.868a.25.25 0 0 1
.25.25v16.475a.25.25 0 0 1-.25.25h-1.75a1 1 0 0 0 0 2h2a2 2 0 0 0 2-2V2a2 2 0
0 0-2-2z"/></g></svg></template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    title: {
      type: String,
      default: 'login',
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
